import { gql } from '@apollo/client';

export const WORKSHEET_CHAT_SEND_MESSAGE_MUTATION = gql`
  mutation WorksheetChatSendMessage($input: WorksheetChatSendMessageInput!) {
    worksheetChatSendMessage(input: $input) {
      message {
        id
        worksheet_id
        user_id
        role
        message
        worksheet_state
        worksheet_changes
        prompt_tokens
        completion_tokens
        total_tokens
        created_at
        updated_at
      }
      changes
      tokenUsage {
        user_id
        total_tokens
        prompt_tokens
        completion_tokens
        token_limit
        usage_percentage
        has_active_subscription
      }
    }
  }
`;

export const GET_WORKSHEET_CHAT_HISTORY_QUERY = gql`
  query GetWorksheetChatHistory($worksheetId: ID!) {
    getWorksheetChatHistory(worksheetId: $worksheetId) {
      id
      worksheet_id
      user_id
      role
      message
      worksheet_state
      worksheet_changes
      prompt_tokens
      completion_tokens
      total_tokens
      created_at
      updated_at
    }
  }
`;

export const GET_USER_TOKEN_USAGE_QUERY = gql`
  query GetWorksheetChatUserTokenUsage {
    getWorksheetChatUserTokenUsage {
      user_id
      total_tokens
      prompt_tokens
      completion_tokens
      token_limit
      usage_percentage
      has_active_subscription
    }
  }
`;
